const CONFIG: Record<
  'active' | 'on_hold' | 'completed',
  { label: string; dotCls: string; wrapCls: string }
> = {
  active: {
    label: 'Active',
    dotCls: 'bg-[hsl(var(--good))]',
    wrapCls: 'text-[hsl(var(--good))] bg-[hsl(var(--good)/0.1)]',
  },
  on_hold: {
    label: 'On Hold',
    dotCls: 'bg-[hsl(var(--warn))]',
    wrapCls: 'text-[hsl(var(--warn))] bg-[hsl(var(--warn)/0.1)]',
  },
  completed: {
    label: 'Completed',
    dotCls: 'bg-muted-foreground/40',
    wrapCls: 'text-muted-foreground bg-muted',
  },
};

export function StatusBadge({ status }: { status: 'active' | 'on_hold' | 'completed' }) {
  const { label, dotCls, wrapCls } = CONFIG[status] ?? CONFIG.completed;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${wrapCls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dotCls}`} />
      {label}
    </span>
  );
}
